<template>
    <div style="" class="cjbg">
        <headerNav title="抽奖" />
        <!-- <div>
            <img style="width: 100%;" src="../../assets/images/cj01.jpg" />
        </div> -->
        <div class="fh" style="margin-top:4vw;" v-if="mydata">
            
            <!-- <div class="fg1" v-if="lastinfos&&lastinfos.length>0">
                 <van-notice-bar  :scrollable="false">
                    <van-swipe
                        vertical
                        class="notice-swipe"
                        :autoplay="1500"
                        :show-indicators="false"
                    >
                    <van-swipe-item v-for="(item,index) in lastinfos" :key="index">{{item.dealerName}}<span style="margin-left:5px;margin-right:5px;">{{item.drawTime}}</span>中了{{item.productName}}</van-swipe-item>
                    </van-swipe>
                </van-notice-bar>
            </div> -->
            <!-- <div v-if="vinfo" :style="{'margin-bottom':'10px',color:$abctheme.basecolor}">当前剩余抽奖次数{{vinfo.useNum}}</div> -->
            <div class="fvinfo" v-if="vinfo">
                <div class="vinfo">
                    当前剩余抽奖次数<span :style="{'margin-left':'5px','color':$abctheme.basecolor}">{{vinfo.useNum}}</span>
                </div>
            </div>
            <div class="fg2">
                
                <div class="lucky-box">
                     <img src="../../assets/images/cj04.jpg" 
                class="lucky-img" style="width:300px;height:300px;display: block;margin: 0 auto;">
                <!-- <img :src="require('./img/yyx/bg.png')" class="lucky-img" /> -->
                <LuckyGrid
                    class="lucky-canvas"
                    ref="LuckDraw"
                    width="300px"
                    height="300px"
                    :prizes="prizes"
                    :blocks="blocks" 
                    :buttons="buttons"
                    :default-style="defaultStyle"
                    :active-style="activeStyle"
                    @start="nnn"
                    @end="endCallBack"
                    style="margin: 0 auto;"
                />
                </div>
               
            </div>
            <div style="margin-top:5px;margin-bottom:15px;text-align: center;">
                <van-button @click="goto('/drawlotterycard')" :color="$abctheme.basecolor" >查看我的奖品</van-button>
            </div>
        </div>

        <div class="fg11">
            <div class="tit">中奖名单：</div>
            
            <div class="fg1">
                <div class="fg10">
                    <div v-for="(item,index) in lastinfos" :key="index">
                        {{item.dealerName}}<span style="margin-left:5px;margin-right:5px;">{{item.drawTime}}</span>中了{{item.productName}}
                    </div>
                </div>
            </div>
        </div>

        <!-- <div>
            <img style="width: 100%;" src="../../assets/images/cjf2.jpg" />
        </div> -->
        
        <!-- <div class="ffmian">
            
        </div> -->
        
        <van-dialog v-model="fshow" title="抽奖情况" @confirm="goto('/drawlotterycard')"  show-cancel-button cancel-button-text="继续抽奖"  showConfirmButton confirmButtonText="领取奖品">
            <div style="color:#a8a8a8;padding:10px;line-height:22px;text-align:center" v-if="curprize">
               <div>
                   恭喜您获得如下奖品
               </div>
               <div style="color:red">
                   {{curprize.drawLotteryProductName}}
               </div>
               <div v-if="curprize.productPic" style="margin-top:5px;">
                   <img  :src="$baseurl+curprize.productPic" style="width:200px;height:200px"/>
               </div>
            </div>
        </van-dialog>

    </div>
</template>
<script>
import { LuckyWheel, LuckyGrid } from 'vue-luck-draw';

export default {
    components:{
        LuckyWheel,
        LuckyGrid
    },
    data () {
    return {
        prizes: [],
        blocks: [
            { padding: '22px', background: 'rgba(0, 0, 0, 0)', borderRadius: '30px' },
        ],
        buttons: [{
            x: 1, y: 1, background: 'rgba(0, 0, 0, 0)',
            fonts: [
            { text: '', fontColor: '#ca620d', top: '0%' }
            ],
            // imgs: [
            // { src: require('../../assets/images/cj.png'), width: '100%', top: '0' }
            // ]
        }],
        defaultStyle: {
            fontColor: '#AFFFD7',
            fontSize: '10px',
            lineHeight: '13px',
            wordWrap: false,
        },
        activeStyle: {
            fontColor: '#fff',
            background:'#ffde00'
        },
        vinfo:undefined,
        mydata:undefined,
        lastinfos:[
            
        ],
        cinfo:{
                dealerName:'小谢',
                drawTime:'2021-05-01',
                productName:'某某商品阿松大逻辑上的啦爱丽丝的就奥克兰'
            },
        curprize:undefined,
        fshow:false,
        isdrawding:false,
        msettingid:undefined,
        drawlist:undefined
    }
  },
  created()
  {
      var isnewreload= localStorage.getItem("isnewreload")||"";
      if(!isnewreload)
      {
        localStorage.setItem("isnewreload","123");
        this.mreloadpage();
      }
      this.querypersoninfo();
      //this.querydrawpersons();
     
  },
  mounted () {
    this.getPrizesList();
  },
  methods: {
    mreloadpage()
    {
        location.reload();
    },
    textgd()
    {

    },
    querydrawpersons(drawid)
    {
        this.ajax.post('/api/services/app/PhoneDrawLottery/QueryLastWinLotteryList?DrawId='+drawid).then(x=>
        {
             this.lastinfos=x.result;
        })
    },
    goto(url)
    {
        this.$router.push({path:url});
    },
    nnn()
    {
        
        //this.startCallBack();
        if(this.vinfo&&this.vinfo.useNum>0)
        {
            if(this.isdrawding)
            {
                this.$toast("抽奖中，请稍后");
                return;
            }else
            {
                //debugger;
                //随机设置一个
                var mwin= this.vinfo.winList.find(x=>x.useNum>0);
                console.log(mwin);
                var settingid= mwin.drawLotterySettingId;
                this.msettingid=settingid;
                
                this.isdrawding=true;
                this.startCallBack();
            }      
        }
        else
        {
            this.$toast("您暂无资格抽奖");
        }
       
    },
    getlist()
    {
        var mmsettingid=undefined;
        if(this.vinfo&&this.vinfo.winList&&this.vinfo.winList.length>0)
        {
            var mwin= this.vinfo.winList.find(x=>x.useNum>0);
            if(!mwin)
            {
                mwin= this.vinfo.winList[0];
            }
            mmsettingid= mwin.drawLotterySettingId;
            this.querydrawpersons(mmsettingid);
        }
        
    },
    querypersoninfo()
    {   
        this.ajax.post('/api/services/app/PhoneDrawLottery/NewQueryPersonInfo').then(x=>
        {
            this.vinfo=x.result;
            //this.buttons[0].fonts[0].text="剩余次数:5次";
            //this.settext(this.vinfo.useNum);
        })
    },
    queryPrizesList()
    {
        this.ajax.post('/api/services/app/PhoneDrawLottery/QueryModel').then(x=>
        {
            // this.mydata=x.result;
            // var vdata= x.result;
            // if(x.result&&x.result.length>0)
            // {
            //     this.mydata=x.result[0].drawLotteryList;
            //     var vdata= x.result[0].drawLotteryList;
            //     this.setprizesdata(vdata);
            // }else
            // {
            //     this.mydata=[];
            // }
            // this.mydata=x.result
            // this.setprizesdata(vdata);
            this.mydata=x.result;
            var vdata= x.result;
            this.setprizesdata(vdata);
        });
    },
    getPrizesList () {
        this.ajax.post('/api/services/app/PhoneDrawLottery/QueryModelList').then(x=>
        {
            this.drawlist=x.result;
            var vdata= x.result;
            this.setprizesdata(vdata);
            if(x.result&&x.result.length>0)
            {
                this.mydata=x.result[0].drawLotteryList;
                var vdata= x.result[0].drawLotteryList;
                this.setprizesdata(vdata);
                this.getlist();
            }else
            {
                this.mydata=[];
            }
        });
    },
    setprizesdata(vdata){
        vdata.sort(() => Math.random() - 0.5);
         let axis = [[0, 0], [1, 0], [2, 0], [2, 1], [2, 2], [1, 2], [0, 2], [0, 1]];
        const prizes = [];
        vdata.forEach((item, index) => {
            prizes.push({
                x: axis[index][0], y: axis[index][1],
                title: item.drawLotteryProductName,
                drawLotteryEnum:item.drawLotteryEnum,
                id:item.id,
                fonts: [{ text: '', top: '0px'}],
                imgs:[]
                // imgs: [
                //     {
                //     src: require('../../assets/images/361.png'),
                //     //src: this.$baseurl+item.productPic,
                //     width: '100%',
                //     height: '100%',
                //     }
                // ],
                
            })
        })
        this.prizes = prizes
    },
    // settext(num){
    //     this.buttons[0].fonts[0].text="剩余次数:"+num+"次";
    // },
    startCallBack() {
     
      var draw= this.drawlist.find(x=>x.id==this.msettingid).drawLotteryList;
      console.log("抽奖",draw);
      this.mydata=draw;
      this.setprizesdata(this.mydata);
      this.$refs.LuckDraw.play()
      
       this.ajax.post('/api/services/app/PhoneDrawLottery/StartDrawLottery?DrawSettingId='+this.msettingid).then(x=>
       {
           var vindex= this.prizes.findIndex(y=>y.id==x.result);
           this.vinfo.useNum-=1;
           this.vinfo.winList.forEach((item)=>
           {
              if(item.drawLotterySettingId==this.msettingid)
              {
                item.useNum-=1;
              }
           })
           this.getlist();
           console.log(this.vinfo.winList);
           //this.vinfo.winList.filter(x=>drawLotterySettingId==this.settingid);
           //console.log(`恭喜你获得${this.prizes[vindex].title}`);
           setTimeout(() => {
            this.isdrawding=false;
            this.$refs.LuckDraw.stop(vindex);
              
           }, 2000);
       }).catch(x=>
       {
           this.isdrawding=false;
           //this.$refs.LuckDraw.stop(0);
       })
    },
    endCallBack (prize) {
        console.log("参数"+prize);
      //替换图片
      var vindex=this.prizes.findIndex(y=>y.id==prize.id);
      var findex=this.mydata.findIndex(y=>y.id==prize.id);
      var vitem=this.mydata[findex];
      var imgs=[{
          src:this.$baseurl+vitem.productPic,
          height:'65%',
          width:'65%',
          top:'10%',
      }]
      this.prizes[vindex].imgs=imgs;
      this.prizes[vindex].fonts[0].text=vitem.drawLotteryProductName;
      this.prizes[vindex].fonts[0].top='75%';
      this.curprize=vitem;
      if(prize.drawLotteryEnum==3)
      {
          this.$toast(`谢谢参与`);
      }
      else
      {
          this.fshow=true;
          //this.$toast(`恭喜你获得${prize.title}`);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.cjbg{
    background: url(../../assets/images/cj01.jpg) no-repeat;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
    padding-bottom:10px;
}

.fh{
    position: relative;
    padding: 0px;
    font-size: 16px;
}


 .notice-swipe {
    height: 40px;
    line-height: 40px;
  }
  .ffmian{
      position: absolute;
      z-index:-2;
      top:0;
      left:0;
      right:0;
      bottom:0;
      background-color: #fff;
  }
  .lucky-box {
    width: 300px;
    height: 300px;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    margin: 0 auto;
  }
  .lucky-img {
    width: 100%;
    height: 100%;
  }
  .lucky-canvas {
    position: absolute;
    left: 0;
    top: 0;
    right:0;
  }
    .fg11{
        font-size: 14px;
        padding: 20px;
        margin: 0px 20px 40px 20px;
        background-color: #00000069;
        color:white;
        border-radius: 12px;
    }
    .fg11 .tit{
        font-size: 16px;
        font-weight: bold;
    }
   .fg1{
        font-size: 16px;
        line-height: 24px;
        border-radius: 16px;
        height: 300px;
        overflow: hidden;
    }
    .fg10
    {
        position: relative;
        word-break: break-all;
        // background-color: #00000029;
        animation:mymove 100s infinite;
	    -webkit-animation:mymove 100s infinite;
    }
    @keyframes mymove
    {
        from {top:0px;}
        to {top:-3500px;}
    }
    .hg{
        width: 200px;
        height: 150px;
        background-color: red;
        z-index:99999;
    }
    .fvinfo{
        text-align: center;
    }
    .vinfo{
        background-color: #00000069;
        color:white;
        border-radius: 10px;
        padding: 5px 0;
        width: 80%;
        margin-bottom: 10px;
        display: inline-block;
    }
</style>